import React, { useState, useEffect } from "react";
import { LinearProgress, Link, Paper, Typography, Box, Grid, Divider } from "@mui/material";
import { useDispatch } from "react-redux";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";

import { unsubscribe } from "../../actions/auth_actions";
import * as ROUTES from "../../constants/routes";

import { ReactComponent as SmLogo } from "../Common/Logo/smLogo.svg";
import { ReactComponent as Mountains } from "./Icons/mountains.svg";

const Unsub = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [completeQuery, setCompleteQuery] = useState(false);
  const [awaitingResponse, setAwaitingResponse] = useState(false);

  const version = `${process.env.REACT_APP_REGION === "eu-west-2" ? "uk." : "ireland."}${process.env.REACT_APP_STAGE}@${process.env.REACT_APP_VERSION}${process.env.REACT_APP_BUILD ? `.${parseInt(process.env.REACT_APP_BUILD, 10)}` : ""}`;

  useEffect(() => {
    const processUrlParams = async () => {
      setAwaitingResponse(true);
      const queryParams = new URLSearchParams(location.search);
      const email = queryParams.get("email");
      if (email) {
        await dispatch(unsubscribe(email));
        setCompleteQuery(true);
        setAwaitingResponse(false);
      } else {
        navigate("/login");
      }
    };

    processUrlParams();
  }, [dispatch, location.search, navigate]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box sx={{ height: { xs: 2, md: 3 } }}>
        {awaitingResponse && <LinearProgress />}
      </Box>

      <Grid container spacing={0} direction="column" justifyContent="center" alignItems="center" sx={{ minHeight: "100vh" }}>
        <Grid item sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Box sx={{
            display: 'flex', justifyContent: 'center',
            maxHeight: { sm: 160 }, width: { xs: '80%', sm: '100%' }, mt: { xs: '15px', sm: 0 },
          }}>
            <SmLogo style={{ width: '100%', height: 'auto' }} />
          </Box>
        </Grid>
        {completeQuery && (
          <Grid item>
            <Paper sx={{
              display: "flex", flexDirection: "column", alignItems: "center",
              minWidth: { xs: 100, sm: 600, md: 720 }, maxWidth: { sm: 600, md: 720 },
            }}>
              <Grid container spacing={0} direction="row-reverse" justifyContent="center" alignItems="stretch" sx={{ minHeight: 200 }}>
                <Grid item size={{xs:12, sm:5}} sx={{
                  backgroundColor: "#FDEFE7", borderTopRightRadius: 8, borderBottomRightRadius: 8,
                  overflow: "hidden", display: { xs: 'none', sm: 'flex' }
                }}>
                  <Mountains sx={{
                    width: "105%", marginLeft: -1, alignSelf: "flex-end", marginBottom: -15,
                    '@media (maxWidth: 600px)': { width: "160%", height: "160%", marginBottom: -20, alignSelf: "flex-start" }
                  }} />
                </Grid>
                <Grid item size={{xs:12, sm:7}}>
                  <Box sx={{ m: { xs: 2, sm: 4 }, mr: { sm: '27px' }, mb: { sm: '20px' } }}>
                    <Typography variant="h4" sx={{ pb: '10px', fontSize: { xs: 25, sm: 32 } }}>
                      You have now been unsubscribed
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#5A6375", fontSize: 14, mt: '3px', mb: 2 }}>
                      You might still receive emails such as invites and responses to job applications.
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#5A6375", fontSize: 14, mt: '3px', mb: 2 }}>
                      To unsubscribe from those emails as well, or to re-subscribe to these job notification emails please visit the setting page of the app.
                    </Typography>
                    <Divider />
                    <Typography variant="body2" sx={{ color: "#5A6375", fontSize: 14, mt: '14px', textAlign: "center" }}>
                      Click to go{" "}
                      <Link component={RouterLink} to={ROUTES.LOGIN}>
                        Login In
                      </Link>
                    </Typography>
                  </Box>
                  <Box sx={{ fontSize: 9, color: "#bbb", textAlign: "right", mt: '3px', mr: 2, mb: '5px' }}>
                    {version}
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default Unsub;
